import { PipelineData } from "../../components/AiPipelineFlow/PipelineTypes"
import { NavbarItems } from "../../components/layout/Sidebar";
import { MessageSquare, BookOpen, Palette, Wrench, Settings, FileText } from 'lucide-react';


// name/description bleiben als Fallback stehen; die Sidebar rendert t(labelKey)/t(descKey) im
// common-Namespace (i18n, Task #76). Neue Nav-Items: labelKey/descKey + Keys in locales/*/common.json.
export const sidebarItems: NavbarItems[] = [
  {
    name: 'Chat',
    labelKey: 'nav.chat',
    descKey: 'nav.chatDesc',
    href: '/chat',
    class: 'nav-item',
    icon: <MessageSquare size={18} strokeWidth={2} />,
    description: 'AI Chat Assistant',
    highlight: true,
    dividerAfter: true,
    subSection: [],
  },
  {
    name: 'Knowledge',
    labelKey: 'nav.knowledge',
    descKey: 'nav.knowledgeDesc',
    href: '/apps/knowledge',
    class: 'nav-item',
    icon: <BookOpen size={18} strokeWidth={2} />,
    description: 'AI assistants for research and analysis',
    subSection: [],
  },
  {
    name: 'Creativity',
    labelKey: 'nav.creativity',
    descKey: 'nav.creativityDesc',
    href: '/apps/creativity',
    class: 'nav-item',
    icon: <Palette size={18} strokeWidth={2} />,
    description: 'Image and video generation tools',
    subSection: [],
  },
  {
    name: 'Tools',
    labelKey: 'nav.tools',
    descKey: 'nav.toolsDesc',
    href: '/apps/tools',
    class: 'nav-item',
    icon: <Wrench size={18} strokeWidth={2} />,
    description: 'Productivity and analysis utilities',
    dividerAfter: true,
    subSection: [],
  },
  {
    name: 'Settings',
    labelKey: 'nav.settings',
    descKey: 'nav.settingsDesc',
    href: '/settings',
    class: 'nav-item',
    icon: <Settings size={18} strokeWidth={2} />,
    description: 'Profile and app settings',
    subSection: [],
  },
];

export const footerItems: NavbarItems[] = [
    {
        name: 'Legal Links',
        labelKey: 'nav.legal',
        descKey: 'nav.legalDesc',
        href: '#',
        class: 'nav-item',
        icon: <FileText size={16} strokeWidth={2} />,
        description: 'Get more informations',
        subSection: [
        {
            name: 'Billing',
            labelKey: 'nav.billing',
            href: '/billing',
            class: 'nav-item',
        },
        {
            name: 'Terms',
            labelKey: 'nav.terms',
            href: '/terms',
            class: 'nav-item',
        },
        {
            name: 'Privacy',
            labelKey: 'nav.privacy',
            href: '/terms',
            class: 'nav-item',
        },
        {
            name: 'Impressum',
            labelKey: 'nav.impressum',
            href: '/impressum',
            class: 'nav-item',
        },
        {
            // § 312k BGB: staendig verfuegbarer Kuendigungsbutton mit eindeutiger Beschriftung
            name: 'Verträge hier kündigen',
            labelKey: 'nav.cancelContracts',
            href: '/kuendigung',
            class: 'nav-item',
        }
    ]
  }
]

/**

Basis-KIs
- Sprachmodell
- Bildgenerator
- Sprachgenerator
- Spracherkennung
- OCR
- Übersetzer
- Musikgenerator
- Liedgenerator
- Videogenerator
- 3D-Modell-Generator

Erweiterte Tools
- Secure GPT
- Mail-to-Object
- Business Summary
- Presentation Generator

Meine Pipelines
- Meine Super-Pipeline


Chatverlauf

 */





/**
 * Diagramm-Samples
 */


/**
 * Basis Tools
 */
export const FlowGPTProxy : PipelineData = {
    nodes: [
        { id: '0', position: { x: 0, y: 0 }, data: { }, type: "inputChat" },
        { id: '1', position: { x: 200, y: 50 }, data: { }, type: "processGPTProxy" },
        { id: '2', position: { x: 400, y: 50 }, data: { }, type: "outputChat" },
    ],
    edges: [
        { id: 'e0-1', source: '0', target: '1', targetHandle: "in-0" },
        { id: 'e1-2', source: '1', target: '2', targetHandle: "in-0" },
    ]
}

export const FlowLargeLanguageModel : PipelineData = {
    nodes: [
        { id: '0', position: { x: 0, y: 0 }, data: { }, type: "inputChat" },
        { id: '1', position: { x: 200, y: 50 }, data: { }, type: "processLLM" },
        { id: '2', position: { x: 400, y: 50 }, data: { }, type: "outputChat" },
    ],
    edges: [
        { id: 'e0-1', source: '0', target: '1', targetHandle: "in-0" },
        { id: 'e1-2', source: '1', target: '2', targetHandle: "in-0" },
    ]
}



export const FlowImageGenerator : PipelineData = {
    nodes: [
        { id: '0', position: { x: 0, y: 0 }, data: { }, type: "inputText" },
        { id: '1', position: { x: 200, y: 50 }, data: { }, type: "processImageGenerator" },
        { id: '2', position: { x: 400, y: 50 }, data: { }, type: "outputImage" },
    ],
    edges: [
        { id: 'e0-1', source: '0', target: '1', targetHandle: "in-0" },
        { id: 'e1-2', source: '1', target: '2', targetHandle: "in-0" },
    ]
}


export const FlowTextToSpeech : PipelineData = {
    nodes: [
        { id: '0', position: { x: 0, y: 0 }, data: { }, type: "inputText" },
        { id: '1', position: { x: 200, y: 50 }, data: { }, type: "processTextToSpeech" },
        { id: '2', position: { x: 400, y: 50 }, data: { }, type: "outputAudio" },
    ],
    edges: [
        { id: 'e0-1', source: '0', target: '1', targetHandle: "in-0" },
        { id: 'e1-2', source: '1', target: '2', targetHandle: "in-0" },
    ]
}




export const FlowSpeechRecognition : PipelineData = {
    nodes: [
        { id: '0', position: { x: 0, y: 0 }, data: { }, type: "inputAudio" },
        { id: '1', position: { x: 200, y: 50 }, data: { }, type: "processSpeechRecognition" },
        { id: '2', position: { x: 400, y: 50 }, data: { }, type: "outputText" },
    ],
    edges: [
        { id: 'e0-1', source: '0', target: '1', targetHandle: "in-0" },
        { id: 'e1-2', source: '1', target: '2', targetHandle: "in-0" },
    ]
}



export const FlowOCR : PipelineData = {
    nodes: [
        { id: '0', position: { x: 0, y: 0 }, data: { }, type: "inputDocument" },
        { id: '1', position: { x: 200, y: 50 }, data: { }, type: "processOCR" },
        { id: '2', position: { x: 400, y: 50 }, data: { }, type: "outputText" },
    ],
    edges: [
        { id: 'e0-1', source: '0', target: '1', targetHandle: "in-0" },
        { id: 'e1-2', source: '1', target: '2', targetHandle: "in-0" },
    ]
}

export const FlowTranslator : PipelineData = {
    nodes: [
        { id: '0', position: { x: 0, y: 0 }, data: { }, type: "inputText" },
        { id: '1', position: { x: 200, y: 50 }, data: { }, type: "processTranslator" },
        { id: '2', position: { x: 400, y: 50 }, data: { }, type: "outputText" },
    ],
    edges: [
        { id: 'e0-1', source: '0', target: '1', targetHandle: "in-0" },
        { id: 'e1-2', source: '1', target: '2', targetHandle: "in-0" },
    ]
}

/**
 * Extended Tools
 */

export const FlowSecureGPT : PipelineData = {
    nodes: [
        { id: '0', position: { x: 0, y: 0 }, data: { }, type: "inputChat" },
        { id: '1', position: { x: 200, y: 50 }, data: { }, type: "processTextAnonymizer" },
        { id: '2', position: { x: 400, y: 50 }, data: { }, type: "processGPTProxy" },
        { id: '3', position: { x: 600, y: 50 }, data: { }, type: "processReverseTextAnonymizer" },
        { id: '4', position: { x: 800, y: 50 }, data: { }, type: "outputChat" },
    ],
    edges: [
        { id: 'e0-1', source: '0', target: '1', targetHandle: "in-0" },
        { id: 'e1-2', source: '1', target: '2', targetHandle: "in-0" },
        { id: 'e1-3', source: '1', target: '3', sourceHandle: "out-1", targetHandle: "in-1" },
        { id: 'e2-3', source: '2', target: '3', targetHandle: "in-0" },
        { id: 'e3-4', source: '3', target: '4', targetHandle: "in-0" },
    ]
}

export const FlowMailToObject : PipelineData = {
    nodes: [
        { id: '0', position: { x: 0, y: 0 }, data: { }, type: "inputChat" },
        { id: '1', position: { x: 200, y: 50 }, data: { }, type: "processTextAnonymizer" },
        { id: '2', position: { x: 400, y: 50 }, data: { }, type: "processGPT" },
        { id: '3', position: { x: 600, y: 50 }, data: { }, type: "processReverseTextAnonymizer" },
        { id: '4', position: { x: 800, y: 50 }, data: { }, type: "outputChat" },
    ],
    edges: [
        { id: 'e0-1', source: '0', target: '1', targetHandle: "in-0" },
        { id: 'e1-2', source: '1', target: '2', targetHandle: "in-0" },
        { id: 'e1-3', source: '1', target: '3', sourceHandle: "out-1", targetHandle: "in-1" },
        { id: 'e2-3', source: '2', target: '3', targetHandle: "in-0" },
        { id: 'e3-4', source: '3', target: '4', targetHandle: "in-0" },
    ]
}


export const FlowBusinessSummary : PipelineData = {
    nodes: [
        { id: '0', position: { x: 0, y: 0 }, data: { }, type: "inputChat" },
        { id: '1', position: { x: 400, y: 50 }, data: { }, type: "processLLM" },
        { id: '2', position: { x: 200, y: 50 }, data: { }, type: "processSqlGenerator" },
        { id: '3', position: { x: 200, y: 50 }, data: { }, type: "processSqlExecutor" },
        { id: '4', position: { x: 400, y: 50 }, data: { }, type: "processLLM" },
        { id: '5', position: { x: 800, y: 50 }, data: { }, type: "outputChat" },
    ],
    edges: [
        { id: 'e0-1', source: '0', target: '1', targetHandle: "in-0" },
        { id: 'e1-2', source: '1', target: '2', targetHandle: "in-0" },
        { id: 'e2-3', source: '2', target: '3', targetHandle: "in-0" },
        { id: 'e3-4', source: '3', target: '4', targetHandle: "in-0" },
        { id: 'e4-5', source: '4', target: '5', targetHandle: "in-0" },
    ]
}


export const FlowPresentationGenerator : PipelineData = {
    nodes: [
        { id: '0', position: { x: 0, y: 0 }, data: { }, type: "inputChat" },
        { id: '1', position: { x: 200, y: 50 }, data: { }, type: "processTextAnonymizer" },
        { id: '2', position: { x: 400, y: 50 }, data: { }, type: "processGPT" },
        { id: '3', position: { x: 600, y: 50 }, data: { }, type: "processReverseTextAnonymizer" },
        { id: '4', position: { x: 800, y: 50 }, data: { }, type: "outputChat" },
    ],
    edges: [
        { id: 'e0-1', source: '0', target: '1', targetHandle: "in-0" },
        { id: 'e1-2', source: '1', target: '2', targetHandle: "in-0" },
        { id: 'e1-3', source: '1', target: '3', sourceHandle: "out-1", targetHandle: "in-1" },
        { id: 'e2-3', source: '2', target: '3', targetHandle: "in-0" },
        { id: 'e3-4', source: '3', target: '4', targetHandle: "in-0" },
    ]
}


export const FlowStickerGenerator : PipelineData = {
    nodes: [
        { id: '0', position: { x: 0, y: 0 }, data: { }, type: "inputChat" },
        { id: '1', position: { x: 200, y: 50 }, data: { }, type: "processTextAnonymizer" },
        { id: '2', position: { x: 400, y: 50 }, data: { }, type: "processGPT" },
        { id: '3', position: { x: 600, y: 50 }, data: { }, type: "processReverseTextAnonymizer" },
        { id: '4', position: { x: 800, y: 50 }, data: { }, type: "outputChat" },
    ],
    edges: [
        { id: 'e0-1', source: '0', target: '1', targetHandle: "in-0" },
        { id: 'e1-2', source: '1', target: '2', targetHandle: "in-0" },
        { id: 'e1-3', source: '1', target: '3', sourceHandle: "out-1", targetHandle: "in-1" },
        { id: 'e2-3', source: '2', target: '3', targetHandle: "in-0" },
        { id: 'e3-4', source: '3', target: '4', targetHandle: "in-0" },
    ]
}



